export const emailId = 'chamanth@yarlagadda.dev';
export const linkedinUrl = 'https://www.linkedin.com/in/chamanthyarlagadda/';
export const githubUrl = 'https://github.com/ChamKrish';
export const resumeFileId = '1htWjW_uoMXZVnBVmKT_Zjh1gAHn5iuRY'